import {gradients} from './gradients'
import {bpmToMs}   from './utils'

export const CONFIG_COOKIE_NAME = 'triangles_config'
export const CONFIG_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365
export const CONFIG_COOKIE_DEBOUNCE_MS = 500

const PERSISTED_CONFIG_KEYS = [
    'dimensions',
    'squareSize',
    'bpm',
    'note',
    'duration',
    'stagger',
    'isUpdating',
    'showInstructions',
    'staggerMode',
    'isSkewed',
    'lockMode',
    'updateMode'
]

export const defaultConfig = {
    dimensions: 10,
    squareSize: 50,
    interval: 2000,
    bpm: 120,
    note: 1,
    duration: 250,
    stagger: 75,
    showInstructions: true,
    isUpdating: true,
    staggerMode: 'outward',
    isSkewed: false,
    lockMode: 'none',
    isLayoutInverted: false,
    colorStops: gradients[0],
    isGradientInverted: false,
    updateMode: 'layout',
    currentLayoutLabel: null,
    sequenceIndex: 0,
    values: []
}

const readCookie = name => {
    const cookie = document.cookie
        .split('; ')
        .find(entry => entry.startsWith(`${name}=`))

    if (!cookie) {
        return null
    }

    try {
        return JSON.parse(decodeURIComponent(cookie.split('=')[1]))
    } catch {
        return null
    }
}

const pickKeys = (source, keys) => {
    return keys.reduce((acc, key) => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            acc[key] = source[key]
        }

        return acc
    }, {})
}

export const buildInitialConfig = () => {
    const storedConfig = readCookie(CONFIG_COOKIE_NAME)

    if (!storedConfig || typeof storedConfig !== 'object') {
        return defaultConfig
    }

    const persistedConfig = pickKeys(storedConfig, PERSISTED_CONFIG_KEYS)
    const lockMode = persistedConfig.lockMode || defaultConfig.lockMode
    const mergedConfig = {
        ...defaultConfig,
        ...persistedConfig,
        updateMode: persistedConfig.updateMode || defaultConfig.updateMode,
        lockMode
    }

    return {
        ...mergedConfig,
        interval: bpmToMs(mergedConfig.bpm, mergedConfig.note)
    }
}

export const toPersistedConfig = config => pickKeys(config, PERSISTED_CONFIG_KEYS)
